import React from 'react';
import { Stack } from 'expo-router';

import { useModalScreenOptions } from '../hooks';

// ─────────────────────────────────────────────────────────────────────────────

export default function ModalsLayout() {
  const screenOptions = useModalScreenOptions();

  return <Stack screenOptions={screenOptions} />;
}
